var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSquareSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-square_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.927 9.44739L13.5055 10.8689C13.0676 11.3067 12.8775 11.9346 12.999 12.5418L13.2985 14.0394L13.3408 14.2507C13.4302 14.698 12.9428 15.0364 12.555 14.7963L11.3099 14.0255C10.7125 13.6557 9.9574 13.6557 9.36005 14.0255L8.11496 14.7963C7.72713 15.0364 7.23971 14.698 7.32917 14.2507L7.37142 14.0394L7.67094 12.5418C7.79239 11.9346 7.60231 11.3067 7.1644 10.8689L5.70442 9.40886C5.36266 9.06713 5.6047 8.48275 6.08802 8.48275H6.16747H7.50228C8.27712 8.48275 8.97007 8.00044 9.2392 7.27384L9.82042 5.70442C9.99731 5.22694 10.6726 5.22694 10.8495 5.70442L11.4307 7.27384C11.6999 8.00044 12.3928 8.48275 13.1677 8.48275H14.5025H14.5275C15.0308 8.48275 15.283 9.09139 14.927 9.44739Z",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 10.335C2 3.47113 3.47113 2 10.335 2C17.1989 2 18.67 3.47113 18.67 10.335C18.67 17.1989 17.1989 18.67 10.335 18.67C3.47113 18.67 2 17.1989 2 10.335Z",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSquareSvgrepocom);
export default __webpack_public_path__ + "static/media/star-square_svgrepo.com.81fba5d2bac466ad6c7ad4ae8dffabb1.svg";
export { ForwardRef as ReactComponent };